import React from "react";
import Page from "components/Page";
import { Card } from "reactstrap";
import styles from "./aisettings.module.scss";
import GearIcon from "../../../assets/images/ai_gear.svg";
import DocumentIcon from "../../../assets/images/document_icon.svg";
import PromptIcon from "../../../assets/images/prompt_icon.svg";
import ReviewIcon from "../../../assets/images/review.svg";
import ChatHistoryIcon from "../../../assets/images/ai-chat-history.svg";
import ResponseReportIcon from "../../../assets/images/ai-response-report.svg";
import constants from "./../../../constants";
import { withTranslation } from "react-i18next";
import Text from "components/Text";

function AISettings({ history, t }) {
  const handleRedirect = (urlToRedirect) => {
    history.push(urlToRedirect);
  };

  const accountList = [
    {
      id: 1,
      chatImg: GearIcon,
      cardName: t("aiAssistant.managementInstruction"),
      onclick: () =>
        handleRedirect(constants.routes.aiAssistant.manageSystemInstruction),
    },
    {
      id: 2,
      chatImg: DocumentIcon,
      cardName: t("aiAssistant.manageDocument"),
      onclick: () =>
        handleRedirect(constants.routes.aiAssistant.manageDocuments),
    },
    {
      id: 3,
      chatImg: PromptIcon,
      cardName: t("aiAssistant.managePrompt"),
      onclick: () => handleRedirect(constants.routes.aiAssistant.managePrompts),
    },
    {
      id: 4,
      chatImg: ReviewIcon,
      cardName: t("aiAssistant.ratingReview"),
      onclick: () =>
        handleRedirect(constants.routes.aiAssistant.ratingResponses),
    },
    {
      id: 5,
      chatImg: ChatHistoryIcon,
      cardName: t("aiAssistant.chatHistory"),
      onclick: () => handleRedirect(constants.routes.aiAssistant.chatHistory),
    },
    {
      id: 6,
      chatImg: ResponseReportIcon,
      cardName: t("aiAssistant.responseReport"),
      onclick: () =>
        handleRedirect(constants.routes.aiAssistant.reportedResponse),
    },
  ];

  const goBack = () => history.push({ pathname: "/manage-owner" });

  return (
    <>
      <Page
        onBack={() => goBack()}
        className={styles["global-main-page"]}
        title={t("aiAssistant.aiSettings")}
      >
        <Text size="14px" weight="300" color="#000000">
          {t("aiAssistant.aiAssistSubheading")}
        </Text>

        <div className={styles["manage-card-container"]}>
          <div className={styles.ai_settings_wrapper}>
            {accountList.map((item) => (
              <div
                className={
                  styles["card-con"] + " " + "form-wrapper cursor-pointer"
                }
                onClick={item.onclick}
                key={item.id}
              >
                <Card
                  className={
                    styles["ai-settings-card"] +
                    " " +
                    "d-flex align-items-center flex-row w-100"
                  }
                >
                  <div className={styles["ai-settings-logo"]}>
                    <img
                      key={item.id}
                      src={item.chatImg}
                      alt="message template icon"
                    />
                  </div>
                  <div className={styles["ai-settings-text"]} key={item.id}>
                    {item.cardName}
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </Page>
    </>
  );
}

export default withTranslation()(AISettings);
